import {Component, EventEmitter, Input, Output} from '@angular/core';
import {Store} from "@ngrx/store";
import {AppState} from "../../store";
import {FavoritesService} from "../../favorites/favorites.service";
import {Overlayable} from "../../interfaces/overlayable";

@Component({
  selector: 'brt-dialog-window',
  templateUrl: './dialog-window.component.html',
  styleUrls: ['./dialog-window.component.scss']
})
export class DialogWindowComponent implements Overlayable {
  @Output('onClosed') onClosed = new EventEmitter<boolean>();
  inProcess = false;
  @Input('confirmCallback') confirmCallback?: () => void;
  @Input('cancelCallback') cancelCallback?: () => void;
  @Input('confirmText') confirmText = "";

  constructor(private store: Store<AppState>, private favorites: FavoritesService) {
  }
  confirm() {
    if(!this.inProcess) {
      this.inProcess = true;

      if(this.confirmCallback) {
        this.confirmCallback();
        this.onClosed.emit(true);
      }
    }
  }
}
